<div class="container-fluid">
  <div class="col-sm-2">
    <div>
      <div>
        <strong>{{ 'label.AnnouncementId' | translate }}: </strong>
        <span class="announcement-id-value">{{
          announcementDetails?.announcementId
        }}</span>
      </div>
    </div>
    <br />
    <div>
      <div>
        <strong>{{ 'label.Views' | translate }}: </strong>
        <span>{{ announcementDetails?.totalViews }}</span>
      </div>
      <div>
        <div *ngFor="let item of announcementDetails?.announcementStats">
          {{ item?.channel?.name }}:&nbsp;{{ item?.totalViewCount }}&nbsp;
        </div>
      </div>
    </div>
    <br />

    <div>
      <div>
        <strong>{{ 'label.Applications' | translate }}: </strong>
        <span>{{ announcementDetails?.totalApplications }}</span>
      </div>
      <div>
        <span
          *ngFor="let item of announcementDetails?.announcementApplicationStats"
          >{{ item?.providerWebsite?.name }}:&nbsp;{{
            item?.AnnouncementApplicationCount
          }}&nbsp;</span
        >
      </div>
    </div>
    <br />

    <div>
      <div>
        <strong>{{ 'label.OrderDetails' | translate }}: </strong>
      </div>
      <div *ngIf="announcementDetails?.orderDetail?.commonItems.length != 0">
        <span *ngFor="let item of announcementDetails?.orderDetail?.commonItems"
          >{{ item?.name }}
        </span>
      </div>
      <div>
        <div
          *ngFor="
            let item of announcementDetails?.orderDetail?.channelOrderDetails
          "
        >
          {{ item?.providerWebsite?.name }}:&nbsp;
          <span *ngFor="let product of item?.productDetails"
            >{{ product?.name }}
            <span
              *ngIf="
                item?.productDetails?.indexOf(product) !=
                item?.productDetails?.length - 1
              "
              >+</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-4">
    <div>
      <strong>{{ 'label.CreateDate' | translate }}: </strong>
      <span *ngIf="announcementDetails?.createDate">{{
        announcementDetails?.createDate | date : 'dd/MM/yy h:mm a'
      }}</span>
      <span *ngIf="!announcementDetails?.createDate">N/A</span>
    </div>
    <br />
    <div>
      <strong>{{ 'label.LastChangeDate' | translate }}: </strong>
      <span *ngIf="announcementDetails?.lastChangeDate">{{
        announcementDetails?.lastChangeDate | date : 'dd/MM/yy h:mm a'
      }}</span>
      <span *ngIf="!announcementDetails?.lastChangeDate">N/A</span>
    </div>
    <br />
    <div>
      <strong>{{ 'label.PriorityExpireDate' | translate }}: </strong>
      <div
        *ngFor="
          let item of announcementDetails?.announcementStats;
          let i = index
        "
      >
        {{ item.channel.name }}:
        <span *ngIf="announcementDetails?.priorityExpireDates[i]">{{
          announcementDetails?.priorityExpireDates[i] | date : 'dd/MM/yy h:mm a'
        }}</span>
        <span *ngIf="!announcementDetails?.priorityExpireDates[i]">N/A</span>
      </div>
    </div>
    <div>
      <strong>{{ 'label.TotalPrice' | translate }}: </strong>
      <span *ngIf="announcementDetails?.totalPrice">{{
        announcementDetails?.totalPrice
      }}</span>
      <span *ngIf="!announcementDetails?.totalPrice">N/A</span>
    </div>
    <div>
      <strong>{{ 'label.PaymentAmount' | translate }}: </strong>
      <span *ngIf="announcementDetails?.paymentPrice">{{
        announcementDetails?.paymentPrice
      }}</span>
      <span *ngIf="!announcementDetails?.paymentPrice">N/A</span>
    </div>
    <div>
      <strong>{{ 'label.Discount' | translate }}: </strong>
      <span>{{
        announcementDetails?.discountPercentage
          ? announcementDetails?.discountPercentage.toFixed(2) + '%'
          : announcementDetails?.discountPercentage
      }}</span>
    </div>
    <div *ngIf="announcementDetails?.moderationChangeLogItems.length > 0">
      <strong
        >{{
          ('label.Logs' | translate) +
            '(' +
            announcementDetails?.moderationChangeLogItems.length +
            ')'
        }}:
      </strong>
      <div
        *ngFor="
          let log of announcementDetails?.moderationChangeLogItems | slice : -2
        "
      >
        <div class="create-user">
          {{ log.createUserFullName }}:
          <span>{{ log.createDate | date : 'dd/MM/yy' }}</span>
        </div>
        <div
          class="process-user"
          [ngStyle]="{ color: changeLogColor(log.status) }"
        >
          {{ log.processUserFullName }}:
          <span>{{ log.processDate | date : 'dd/MM/yy' }}</span>
        </div>
      </div>
    </div>
    <br />
  </div>

  <div class="col-sm-3">
    <div>
      <div>
        <strong>{{ 'label.ScheduledRenewalDates' | translate }}:</strong>
      </div>
      <div *ngIf="announcementDetails?.scheduledRenewalDates?.length != 0">
        <div *ngFor="let item of announcementDetails?.scheduledRenewalDates">
          <div *ngIf="item">
            {{ item | date : 'dd/MM/yy h:mm a' }}
          </div>
          <div *ngIf="!item">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-3">
    <div>
      <div>
        <strong>{{ 'label.ActualRenewalDates' | translate }}:</strong>
      </div>
      <div *ngIf="announcementDetails?.actualRenewalDates?.length != 0">
        <span *ngFor="let item of announcementDetails?.actualRenewalDates">
          <div *ngIf="item">
            {{ item | date : 'dd/MM/yy h:mm a' }}
          </div>
          <div *ngIf="!item">&nbsp;</div>
        </span>
      </div>
    </div>
  </div>

  <div class="col-sm-3">
    <div>
      <div></div>
      <div *ngIf="announcementDetails?.customerId" class="company-profile">
        <div (click)="onLoginAsCustomer(announcementDetails?.customerId)" class="customer-login"
          
          ><svg-icon
            src="assets/img/go_to_company_profile.svg"
            [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"
          ></svg-icon
          ><span>{{ 'label.GoToCompanyProfile' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
